class SizeGuide extends HTMLElement {
  connectedCallback() {
    const linkText = this.getAttribute('link-text') || 'Size Guide';
    const titleText = this.getAttribute('modal-title') || 'Size Guide';
    const contentUrl = this.getAttribute('data-url');
    this.productType = this.getAttribute('data-product-type') || '';

    const templateHtml = `
      <button class="size-guide__trigger" aria-haspopup="dialog">${linkText}</button>
      <div class="size-guide__backdrop" aria-hidden="true"></div>
      <dialog class="size-guide__dialog" aria-label="${titleText}">
        <div class="size-guide__modal" role="document">
          <div class="size-guide__header">
            <div class="size-guide__title">${titleText}</div>
            <button class="size-guide__close" aria-label="Close">×</button>
          </div>
          <div class="size-guide__content">Loading…</div>
        </div>
      </dialog>
    `;

    this.classList.add('size-guide');
    this.innerHTML = templateHtml;

    this._trigger = this.querySelector('.size-guide__trigger');
    this._dialog = this.querySelector('.size-guide__dialog');
    this._backdrop = this.querySelector('.size-guide__backdrop');
    this._close = this.querySelector('.size-guide__close');
    this._content = this.querySelector('.size-guide__content');

    this._open = this._open.bind(this);
    this._closeModal = this._closeModal.bind(this);

    this._trigger.addEventListener('click', this._open);
    this._close.addEventListener('click', this._closeModal);
    this._backdrop.addEventListener('click', this._closeModal);
    this._dialog.addEventListener('close', () => this.classList.remove('is-open'));

    if (contentUrl) {
      fetch(contentUrl, { credentials: 'same-origin' })
        .then((r) => r.text())
        .then((html) => {
          const container = document.createElement('div');
          container.innerHTML = html;

          const styles = container.querySelectorAll('style, link[rel="stylesheet"]');

          const tabsContent = container.querySelector('.tabs');

          this._content.innerHTML = '';

          styles.forEach((style) => {
            this._content.appendChild(style);
          });

          if (tabsContent) {
            this._content.appendChild(tabsContent);

            this._setActiveTab();
          } else {
            this._content.textContent = 'Size guide table not found.';
          }
        })
        .catch((e) => {
          console.error(e);
          this._content.textContent = 'Unable to load size guide.';
        });
    }
  }

  disconnectedCallback() {
    this._trigger?.removeEventListener('click', this._open);
    this._close?.removeEventListener('click', this._closeModal);
    this._backdrop?.removeEventListener('click', this._closeModal);
  }

  _setActiveTab() {
    const type = this.productType.toLowerCase().trim();
    let targetIndex = 0; // Default: Bras

    if (type.includes('bra')) {
      targetIndex = 0;
    } else if (type.includes('corset') || type.includes('bodysuit')) {
      targetIndex = 1;
    } else if (
      type.includes('skirt') ||
      type.includes('trouser') ||
      type.includes('robe') ||
      type.includes('loungewear')
    ) {
      targetIndex = 2;
    } else if (type.includes('panties') || type.includes('panty')) {
      targetIndex = 3;
    }

    const tabButtons = this._content.querySelectorAll('.tabs__button');
    const tabBlocks = this._content.querySelectorAll('.tabs__block');

    tabButtons.forEach((btn) => btn.classList.remove('tabs__button--active'));
    tabBlocks.forEach((block) => block.classList.remove('tabs__block--active'));

    if (tabButtons[targetIndex]) {
      tabButtons[targetIndex].classList.add('tabs__button--active');
    }
    if (tabBlocks[targetIndex]) {
      tabBlocks[targetIndex].classList.add('tabs__block--active');
    }
  }

  _open(event) {
    event.preventDefault();
    this.classList.add('is-open');
    document.documentElement.classList.add('size-guide-lock');
    document.body.classList.add('size-guide-lock');
    if (typeof this._dialog.showModal === 'function') {
      this._dialog.showModal();
    } else {
      this._dialog.setAttribute('open', '');
    }
  }

  _closeModal() {
    this.classList.remove('is-open');
    document.documentElement.classList.remove('size-guide-lock');
    document.body.classList.remove('size-guide-lock');
    if (typeof this._dialog.close === 'function') {
      this._dialog.close();
    } else {
      this._dialog.removeAttribute('open');
    }
  }
}

customElements.define('size-guide', SizeGuide);
